import { render, staticRenderFns } from "./GrantHeader.vue?vue&type=template&id=7db626c2"
import script from "./GrantHeader.vue?vue&type=script&lang=js"
export * from "./GrantHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports